/**
 * App-owned enum copied from the legacy GraphQL schema before it dropped it. The transaction
 * filter UI and persisted user settings are keyed on it, and the consumer-API `type` strings
 * are mapped to and from it (`LEGACY_TO_BFF_*` / `BFF_TO_LEGACY_*`). It lives here rather
 * than in `@/types/enums` because that module is reserved for copies that must keep
 * byte-parity with the generated GraphQL schema.
 */

export enum TransactionType {
  MarketBorrow = 'MarketBorrow',
  MarketLiquidation = 'MarketLiquidation',
  MarketRepay = 'MarketRepay',
  MarketSupply = 'MarketSupply',
  MarketSupplyCollateral = 'MarketSupplyCollateral',
  MarketWithdraw = 'MarketWithdraw',
  MarketWithdrawCollateral = 'MarketWithdrawCollateral',
  MetaMorphoDeposit = 'MetaMorphoDeposit',
  MetaMorphoFee = 'MetaMorphoFee',
  MetaMorphoTransfer = 'MetaMorphoTransfer',
  MetaMorphoWithdraw = 'MetaMorphoWithdraw'
}
